<template>
  <el-container
    v-bind:style="{height: windowHeight + 'px'}"
    v-loading="user == null && permissions == null"
  >
    <el-header style="text-align: right; height: auto; padding: 0px; z-index: 2;">
      <el-row type="flex" :class="{ admin: admin}" class="row-bg nxs-header">
        <i
          style="margin: auto auto auto 8px;"
          class="material-icons-outlined header-icon clickable"
          :class="{ active: !collapsed }"
          @click="toggleMenu"
        >menu</i>
        <div style="display: flex;">
          <el-button
            v-if="$store.state.user.primary_position != null"
            style="margin: auto 8px auto 8px;"
            class="admin-button"
            size="mini"
            round
            @click="toggleAdmin"
          >Admin</el-button>
          <el-popover
            style="margin-top: auto; margin-bottom: auto;"
            placement="bottom"
            trigger="click"
          >
            <div>
              <div style="width: 350px; max-height:500px; overflow-y: auto;">
                <transition-group
                  name="slide-out-blurred-right"
                  v-if="notifications != null && notifications.length != 0"
                >
                  <div
                    v-for="o in notifications"
                    :key="o.id"
                    class="text item"
                    @click="clickNotification(o)"
                  >
                    <div class="list-tile" style="position: relative;">
                      <i class="close-button el-icon-close" @click.stop="deleteNotification(o.id)" />
                      <span
                        style="margin-top: 0px; margin-right: 32px;"
                        class="list-title"
                      >{{ o.data.title }}</span>
                      <div>
                        <div class="list-subtext">{{ o.data.message }}</div>
                        <div
                          style="color: #ababab; margin-top: 4px;"
                          class="list-subtext"
                        >{{ moment(o.updated_at).fromNow() }}</div>
                      </div>
                    </div>
                  </div>
                </transition-group>
                <span v-else style="padding: 32px 0px;" class="center-message">No Notifications</span>
              </div>
              <div style="display: flex; padding-top: 8px;">
                <el-button
                  class="mgra"
                  size="mini"
                  type="text"
                  :disabled="notifications == null || notifications.length == 0"
                  @click="deleteAllNotifications"
                >Delete All</el-button>
                <el-button
                  size="mini"
                  type="text"
                  :disabled="notifications == null || notifications.length == 0"
                  @click="readAllNotifications"
                >Mark All Read</el-button>
              </div>
            </div>
            <el-badge
              slot="reference"
              class="nright-button"
              style="margin-right: 24px;"
              :hidden="notifications.filter(o => o.read_at == null).length == 0"
              :value="notifications.filter(o => o.read_at == null).length"
            >
              <i
                style="border: 0px; vertical-align: middle; font-size: 22px; margin: 0px;"
                class="el-icon-bell notification-button header-icon"
              />
            </el-badge>
          </el-popover>
          <div class="vertical-break" />
          <div @click="showProfile($store.state.user)" class="clickable">
            <el-avatar
              :src="$store.state.user.image_uri == null ? '/images/profile_placeholder.png' : $store.state.user.image_uri"
            ></el-avatar>
          </div>
        </div>
      </el-row>
    </el-header>
    <el-container>
      <el-aside v-if="$mq !== 'xs'" style="width: auto;">
        <nxs-menu :collapsed="collapsed" :admin="admin"/>
      </el-aside>
      <el-main style="padding: 0;" v-bind:style="{height: (windowHeight - 58) + 'px'}">
        <div style="width: 100%;">
          <transition name="fade" mode="out-in" appear>
            <router-view />
          </transition>
        </div>
      </el-main>
    </el-container>
    <el-drawer
      class="user-drawer"
      :visible.sync="userDrawerOpen"
      :size="$mq == 'xs' ? '100%' : '500px'"
      direction="rtl"
    >
      <nxs-user-profile :userId="user.o_id" />
    </el-drawer>
    <el-dialog
      :visible.sync="menuDialogVisible"
      :fullscreen="$mq === 'xs'">
      <nxs-menu @closeModal="closeMenuModal" :collapsed="collapsed" :admin="admin"/>
    </el-dialog>
  </el-container>
</template>
<style>
.user-drawer .el-drawer__body {
  height: 100%;
}
</style>

<script>
import nxsUserProfile from "./shared/Profile.vue";
import nxsMenu from "./Navigation.vue";

export default {
    components: {nxsUserProfile, nxsMenu},
    props: {
        permissions: {required: true},
        users: {required: true},
        user: {required: true},
        canapprove: {required: true},
        currentterm: {required: true}
    },
    data() {
        return {
            menuDialogVisible: false,
            loading: true,
            admin: false,
            userDrawerOpen: false,
            collapsed: false,
            notifications: []
        };
    },
    created() {
        if (this.$route.path.includes("/admin")) {
            if (this.permissions.length == 0) {
                this.navigate("/");
                this.admin = false;
            }
        }
        this.$store.commit("setPermissions", this.permissions);
        this.$store.commit("setUser", this.user);
        this.$store.commit("setCanApprove", this.canapprove);
        this.$store.commit("setUsers", this.users);
        this.$store.commit("setCurrentTerm", parseInt(this.currentterm, 10));
    },
    mounted() {
        if (this.$route.path == "/home/ops-order") {
            window.location = "/f/pdf/ops-order.pdf";
        }
        if (this.$route.path == "/home/org-chart") {
            window.location = "/f/pdf/org-chart.pdf";
        }
        if (this.terms == null) this.$store.dispatch("pullTerms");
        if (this.$route.path.includes("/admin")) {
            this.admin = true;
        }
        this.axios
            .get("/api/v1/notifications", {
                headers: {"Content-Type": "application/json"},
                credentials: "same-origin"
            })
            .then((response) => {
                this.$set(this, "notifications", response.data);
            })
            .catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: "Notifications Unavailable",
                    type: "error"
                });
            });
    },
    methods: {
        closeMenuModal() {
            if (this.$mq === 'xs') {
                this.collapsed = false;
                this.menuDialogVisible = false;
            }
        },
        toggleMenu() {
            if (this.$mq === 'xs') {
                this.collapsed = false;
                this.menuDialogVisible = !this.menuDialogVisible;
            }else {
                this.collapsed = !this.collapsed;
            }
        },
        clickNotification(notification) {
            notification.read_at = "now";
            this.axios
                .post(
                    "/api/v1/notifications/markread",
                    {ids: [notification.id]},
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then(() => {
                    window.location = notification.data.url;
                })
                .catch((err) => {
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        readAllNotifications() {
            this.axios
                .post("/api/v1/notifications/read/all", {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.notifications.forEach((n) => {
                        n.read_at = 1;
                    });
                })
                .catch((err) => {
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        deleteAllNotifications() {
            this.axios
                .delete("/api/v1/notifications/delete/all", {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.notifications = [];
                })
                .catch((err) => {
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        deleteNotification(id) {
            this.axios
                .delete("/api/v1/notifications/" + id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    var index = this.notifications.indexOf(
                        this.notifications.find((notification) => notification.id == id)
                    );
                    if (index > -1) {
                        this.notifications.splice(index, 1);
                    }
                })
                .catch((err) => {
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        navigate(route) {
            this.$router.push(route);
            if (this.$mq == "xs") this.collapsed = false;
        },
        toggleAdmin() {
            if (this.admin) {
                this.$router.push("/");
            } else {
                this.$router.push("/admin");
            }
            this.admin = !this.admin;
        },
        showProfile() {
            this.userDrawerOpen = true;
        }
    }
};
</script>
